import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding-top: 64px;
	transition: opacity 0.3s ease;
	background-color: #111111;

	&.apps-enter {
		opacity: 0;
	}

	&.apps-enter-active,
	&.apps-enter-done,
	&.apps-exit {
		opacity: 1;
	}

	&.apps-exit-active {
		opacity: 0;
	}
`;

export { StyledContainer };
